import React from 'react';
import EnquiryManager from '../components/enquiry'

class EnquiryPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<EnquiryManager />
			</div>
		)
	}

}

export default EnquiryPage;


// WEBPACK FOOTER //
// ./src/containers/enquiry-page.js